/**
 * Cart popup autohandler.
 *
 * Usage:
 *
 *  data-sw-custom-model
 */

var $ = require('js/sw-jquery/sw-jquery');
var _ = require('underscore');

module.exports = function($fragment) {

	$fragment.swFindWithSelf('[data-sw-custom-model]').each(function() {
    var $el = $(this);

    var spin = $el.data('swCustomModel');
    var modelId = $el.data('swCustomModelFastModelId');
    // var pconfId = $el.data('swCustomModelConfigId');

    require(['js/lib/components/CustomMaker', 'js/lib/views/CustomModel', 'js/lib/models/ModelManager'], function(customMakerComponent, CustomModelView, ModelManager) {

      // C-maker variables are keyed to model
      // id on the backend
      var cMakerModelId = modelId;

      // Used to determine whether or not to refresh the cocreator form field stuff in customMakerComponent.initModelData
      var cMakerModelExists = ModelManager.checkCustomMakerModel(cMakerModelId);

      // It's okay if the c-maker model hasn't been instantiated yet
      var customMakerModel = ModelManager.getCustomMakerModel(cMakerModelId);

      // depends on server data
      var fastModelPromise = $.Deferred();
      var fastModel = ModelManager.getFastModel(modelId);

      // TODO It could be useful to have a getAsyc method on ModelManager that
      // returns a promise resolved by this very logic
      if (fastModel.isFetching()) {
        fastModel.once('fetchSuccess', function() {
          fastModelPromise.resolve();
        });
      } else {
        fastModelPromise.resolve();
      }


      var productPromise = $.Deferred();
      var productModel = ModelManager.getProduct(spin);
      // TODO It could be useful to have a getAsyc method on ModelManager that
      // returns a promise resolved by this very logic
      if (productModel.isFetching()) {
        productModel.once('fetchSuccess', function() {
          productPromise.resolve();
        });
      } else {
        productPromise.resolve();
      }

      // Wait til we have fastModel data before proceeding
      $.when(fastModelPromise, productPromise).then(function() {

        // Populate model manager form fields with the data contained in fastmodel
        //
        // TODO Make everything depend only on fast model
        var cocreatorFormFields = fastModel.getCocreatorFormFieldData();
        var currentFormField;
        _.each(cocreatorFormFields, function(formField) {

          currentFormField = ModelManager.getCocreatorFormField(formField.id);
          currentFormField.set(formField);

        });

        // init variable attribute data
        //
        // TODO rely on FastModel.js alone
        var formFields = ModelManager.getCocreatorFormFieldMultiple(fastModel.getCocreatorFormFieldIds());
        formFields.each(function(formField) {
          var attributes = formField.getCocreatorVariableAttributeData();

          _.each(attributes, function(attribute) {
            var variableAttribute = ModelManager.getCocreatorVariableAttribute(attribute.id);
            variableAttribute.set(attribute);
          });

          var attributeModels = ModelManager.getCocreatorVariableAttributeMultiple(formField.getCocreatorVariableAttributeIds());
          formField.set({
            cocreatorVariableAttributes: attributeModels
          });
        });

        // Make sure we only run the init data once!
        if (!cMakerModelExists) {
          customMakerComponent.initModelData(fastModel, formFields, !cMakerModelExists);
        }

        new CustomModelView({
          el: $el,
          model: customMakerModel,
          isFullColorMaterial: productModel.isFullColorMaterial(),
          currentModelUrls: fastModel.toJSON()
        });
      });

    });
  });

};
